export enum FeatureType {
  CARE_PLAN = 'carePlan',
  CLINICAL_IMPRESSION_SUGGESTIONS_ML = 'clinicalImpressionSuggestionsMl',
  DYNAMIC_MESSAGE_RENDERING = 'dynamicMessageRendering',
  EDIT_PATIENT_ACCOUNT_DEI = 'editPatientAccountDei',
  EDIT_PROVIDER_ACCOUNT_DEI = 'editProviderAccountDei',
  HEARTBEAT_ERROR_LOGGING = 'heartbeatErrorLogging',
  LAB_ORDERING = 'labOrdering',
  PATIENT_HISTORY_SCORES = 'patientHistoryScores',
  PATIENT_INFO_TAB_CONFIRMATIONS = 'patientInfoTabConfirmations',
  PROVIDER_DELETE_MESSAGES = 'providerDeleteMessages',
  PROVIDER_LOCAL_STORAGE = 'providerLocalStorage',
  RTE_SUBSCRIBER_ID_FLOW = 'rteSubscriberIdFlow',
  SEND_TO_EHR = 'sendToEhr',
  VIDEO_SESSION_LIVE_TRANSCRIPTION = 'videoSessionLiveTranscription',
}

export enum LanguageCodes {
  ENGLISH = 'en',
  SPANISH = 'es',
}

export const Languages = {
  ENGLISH: {
    label: 'English',
    value: LanguageCodes.ENGLISH,
  },
  SPANISH: {
    label: 'Español',
    value: LanguageCodes.SPANISH,
  },
}
